// @ts-nocheck

import { v4 } from 'uuid';

import networkActions from '../../../../actions/network';
import { Target } from '../../../../client';
import { type HandlerProps } from '../../../../store/synchronousMiddleware';
import { RouterActionTypes } from '../../../../types/actions/router';
import { showWebsiteLoginForm } from '../../../../utils';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import { fillTemporaryKLNotification, setKLHomeVisitedIndex } from '../../actions/kl';
import { KLStateActionTypes } from '../../types/actions/kl';
import { KLRoutesActionTypes } from '../../types/actions/routes';

const handleOpenKLView = ({ history, state }) => {
  const alreadyInKL = history.location.pathname === RoutesRedirectionFactory.getKLRoutePathname();

  if (!alreadyInKL) {
    const { user } = state ?? {};
    const { connected } = user ?? {};

    if (!connected) {
      if (Target.__MOBILE__) {
        history.push(
          RoutesRedirectionFactory.getLoginRouteConfig({
            state: { modal: true },
          }),
        );
      } else {
        history.goBackOrReplace(RoutesRedirectionFactory.getHomeRouteConfig());
        showWebsiteLoginForm();
      }
    } else {
      history.push(RoutesRedirectionFactory.getKLRouteConfig());
    }
  }
};

export const handledActionTypes = [
  KLRoutesActionTypes.OPEN_KL_VIEW,
  KLStateActionTypes.FLUSH_KL_NOTIFICATIONS,
  RouterActionTypes.ROUTE_HAS_CHANGED,
  KLStateActionTypes.RESTART_KL_ADVENTURE,
];

const KLMiddlewareHandler = ({ store: { dispatch, getState }, action, params: { history } }: HandlerProps) => {
  if (handledActionTypes.indexOf(action.type) !== -1) {
    const state = getState();

    if (action.type === KLRoutesActionTypes.OPEN_KL_VIEW) {
      handleOpenKLView({ history, state });
    }

    if (action.type === KLStateActionTypes.FLUSH_KL_NOTIFICATIONS) {
      const uniqId = v4();
      dispatch(
        networkActions.send({
          kohlanta: {
            method: 'flushNotifications',
            id: uniqId,
          },
        }),
      );
    }

    if (action.type === KLStateActionTypes.RESTART_KL_ADVENTURE) {
      const uniqId = v4();
      dispatch(
        networkActions.send({
          kohlanta: {
            method: 'restart',
            id: uniqId,
          },
        }),
      );
    }

    if (action.type === RouterActionTypes.ROUTE_HAS_CHANGED) {
      const { payload: { pathname } = {} } = action;

      if (pathname.indexOf(RoutesRedirectionFactory.getKLRoutePathname()) === -1) {
        const { kl } = state;
        const { misc } = kl;
        const { homeVisitedIndex } = misc ?? {};

        if (typeof homeVisitedIndex === 'number') {
          dispatch(setKLHomeVisitedIndex(null));
        }
      }

      if (pathname === RoutesRedirectionFactory.getKLRoutePathname()) {
        dispatch(fillTemporaryKLNotification());
      }
    }
  }
};

export default KLMiddlewareHandler;
